<template>
  <layout-auth-page :page-data="pageData" v-if="pageInit" :page-params="pageParams"/>
</template>

<script>
import layoutAuthPage from "../layouts/layout-auth-page";

export default {
  name: "page-auth",
  components: {
    layoutAuthPage
  },
  data() {
    return {
      pageData: null,
      pageInit: false,
      pageParams: {
        startInNew: false,
        passPolicy: null,
        startNewParam: null,
      },
    }
  },
  created() {
    const defaultPasswordPolicy = {
      PASSWORD_DIGITS: "Y",
      PASSWORD_LENGTH: 6,
      PASSWORD_LOWERCASE: "Y",
      PASSWORD_PUNCTUATION: "Y",
      PASSWORD_UPPERCASE: "Y",
    }
    if (typeof PASSWORD_POLICY !== 'undefined') {
      this.pageParams.passPolicy = Object.assign(defaultPasswordPolicy, PASSWORD_POLICY);
    } else {
      this.pageParams.passPolicy = defaultPasswordPolicy;
    }

    const paramsString = document.location.search;
    const searchParams = new URLSearchParams(paramsString);
    if (searchParams.has('change_password') && searchParams.get('change_password') === 'yes') {
      if (searchParams.has('USER_LOGIN') && searchParams.has('USER_CHECKWORD')) {
        this.pageParams.startInNew = true;
        this.pageParams.startNewParam = {
          USER_LOGIN: searchParams.get('USER_LOGIN'),
          USER_CHECKWORD: searchParams.get('USER_CHECKWORD')
        };
      } else {
        console.error('Не указаны USER_L... и USER_C...')
      }
    }

    this.$api.getAuthPage().then(response => {
      this.pageData = response.data.data;
      this.pageInit = true;
      console.log('Успех')
      console.log(this.pageData)
    }).catch(err => {
      console.error('Axios ERROR')
      console.log(err)
    })
  }
}
</script>